import cloneDeep from 'lodash/cloneDeep';
import groupBy from 'lodash/groupBy';
import lodashGet from 'lodash/get';
import { util } from '@/api/util';
export const getContactLabel = (name) => {
    let contactLabel = name ? name.charAt(0).toLocaleUpperCase() : '';
    if (/[^A-Z]/.test(contactLabel)) {
        contactLabel = '|';
    }
    return contactLabel;
};
export const getContactPYLabel = (name) => {
    const pinyinName = name.split('').map((item) => util.toPinyin(item));
    const res = pinyinName.reduce((pre, cur) => {
        pre += cur.charAt(0).toLocaleLowerCase();
        return pre;
    }, '');
    return res;
};
export const getFlatStrOrArrInfo = (arr, type, rs) => {
    const newArr = [];
    arr.forEach((val) => {
        const res = rs ? Object.assign({}, rs) : {};
        if (type) {
            res.contactItemType = type;
            res.isDefault = 1;
        }
        try {
            if (val.startsWith('[') && val.endsWith(']')) {
                const list = JSON.parse(val);
                list.forEach(item => {
                    if (type) {
                        res.contactItemVal = item;
                        newArr.push(res);
                    }
                    else {
                        newArr.push(item);
                    }
                });
            }
            else if (type) {
                res.contactItemVal = val;
                newArr.push(res);
            }
            else {
                newArr.push(val);
            }
        }
        catch (e) {
            console.error('[contact] getFlatStrOrArrInfo', e);
            newArr.push(val);
        }
    });
    return newArr;
};
export const transformContactModel = (data) => {
    const { contactInfoList = [], contactList = [], orgData, needOrgData, orderByIdList, contactIdMap, contactInfoIdMap, _account } = data;
    const contactMap = contactIdMap || util.listToMap(contactList, 'id');
    const idList = orderByIdList || Object.keys(contactMap);
    const contactInfoMap = contactInfoIdMap || groupBy(contactInfoList, item => item.contactId);
    const { flattenMuliptleEmails } = data;
    const contactModelList = [];
    idList.forEach(id => {
        const contact = contactMap[id];
        if (!contact) {
            return;
        }
        const enableFlatten = flattenMuliptleEmails && contact.type === 'personal' && lodashGet(contact, 'hitQuery.length', 0) > 0;
        contact.color = util.getColor(contact.accountName);
        const contactInfo = contactInfoMap[id] || [
            {
                contactItemType: 'EMAIL',
                contactItemVal: contact.accountName,
                type: contact.type,
                contactId: contact.id,
                id: util.getUnique(contact.id, contact.type, contact.accountName),
                contactItemRefer: '',
                isDefault: 1,
            },
        ];
        if (enableFlatten) {
            contactInfo.forEach(item => {
                if (item.contactItemType !== 'EMAIL') {
                    return;
                }
                const contactModelClone = cloneDeep(contact);
                contactModelClone.hitQueryEmail = item.contactItemVal;
                const model = {
                    contact: contactModelClone,
                    contactInfo: [item],
                    _account,
                };
                contactModelList.push(model);
            });
        }
        else {
            const model = {
                contact,
                contactInfo,
                _account,
            };
            if (needOrgData && orgData) {
                model.orgs = orgData[id];
            }
            contactModelList.push(model);
        }
    });
    return contactModelList;
};
export const transExclude2FilterCondition = (exclude, item) => {
    return exclude.length
        ? !exclude.some(excludeItem => {
            let bool;
            const { val } = excludeItem;
            const { key } = excludeItem;
            if (Array.isArray(val)) {
                bool = val.includes(item[key]);
            }
            else {
                bool = item[key] === val;
            }
            return bool;
        })
        : true;
};
export const transInclude2FilterCondition = (include, item) => {
    return include && include.length > 0
        ? !include.some(includeItem => {
            let bool;
            const { val } = includeItem;
            const { key } = includeItem;
            if (Array.isArray(val)) {
                bool = !val.includes(item[key]);
            }
            else {
                bool = item[key] !== val;
            }
            return bool;
        })
        : true;
};
